import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-manage-access-to-report.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from 'jquery';
var WpbbsaManageAccessToReport = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaManageAccessToReport, _super);
    function WpbbsaManageAccessToReport(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    WpbbsaManageAccessToReport.prototype.init = function () {
        // Loader
        this.formLoader = this.element.querySelector(".form__loader--container");
        // Modal
        this.modals = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-rich-text-modal-modal-open'));
        this.closeButton = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal-close'));
        // Variables
        this.pdfContent = this.element.querySelector('a[name=pdf-content]');
        // Consents
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        // containers
        this.containerFields = this.element.querySelector(".form__fields--container");
        this.containerModal = this.element.querySelector(".js-apply-now-modal");
        // Button submit
        this.buttonSubmit = this.element.querySelector(".js-submit");
        // the form
        this.form = this.element.querySelector("form");
    };
    WpbbsaManageAccessToReport.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.closeButton.map(function (item) { return item.addEventListener('click', function (event) {
            _this.closeModal();
        }); });
        this.pdfContent.addEventListener('click', function (event) {
            _this.closeModal();
        });
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.buttonSubmit.addEventListener("click", function (event) {
            var formFields = _this.form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.formLoader.classList.add('active');
                var fields = _this.containerFields;
                fields.classList.add("d-none");
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.action();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.action();
                    }
                }
                else {
                    _this.action();
                }
            }
        });
    };
    WpbbsaManageAccessToReport.prototype.action = function () {
        var _this = this;
        var activeModal = this.containerModal;
        var pdfContentLink = this.pdfContent.getAttribute("href");
        var pdfContentLinkLength = pdfContentLink.split('/').length;
        // fields
        var product = this.form.querySelector('input[name=product]');
        var recipient = this.form.querySelector('input[name=recipient]');
        var email = this.form.querySelector('input[name=email]');
        var subject = this.form.querySelector('input[name=subject]');
        var pdfDownloadName = pdfContentLink.split('/')[pdfContentLinkLength - 1];
        ;
        var firstName = this.form.querySelector('input[name=first-name]');
        var lastName = this.form.querySelector('input[name=last-name]');
        var contactNumber = this.form.querySelector('input[name=contact-number]');
        var emailAddress = this.form.querySelector('input[name=email-address]');
        var popiaConsent = this.form.querySelector("input[name=popia-consent]");
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/leadsutils/createpebook';
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var _postData = {
            'product': (product ? product.value : ""),
            'recipient': (recipient ? recipient.value : ""),
            'email': (email ? email.value : ""),
            'subject': (subject ? subject.value : ""),
            'pdfDownloadName': (pdfDownloadName ? pdfDownloadName : ""),
            'firstName': (firstName ? firstName.value : ""),
            'lastName': (lastName ? lastName.value : ""),
            'contactNumber': (contactNumber ? contactNumber.value : ""),
            'emailAddress': (emailAddress ? emailAddress.value : ""),
            'dataPrivacyConsent': (popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO"),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(this.form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(this.form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(this.form, 'data-sharing-boarders'),
            'recaptchaToken': this.gRecaptchaToken
        };
        // service
        this.formsService.postForm(url, _postData, config).then(function (response) {
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                // Analytics
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                // Modals
                activeModal.classList.remove('modal--closed');
                activeModal.classList.add('js-rich-text-modal-modal--opened');
                _this.formLoader.classList.remove('active');
            }
            else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                // Analytics
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                // Modals
                activeModal.classList.remove('modal--closed');
                activeModal.classList.add('js-rich-text-modal-modal--opened');
                _this.formLoader.classList.remove('active');
            }
            else {
                // Analytics
                analyticsService.dtmFormComplete('complete');
                // Modals
                activeModal.classList.remove('modal--closed');
                activeModal.classList.add('js-rich-text-modal-modal--opened');
                _this.formLoader.classList.remove('active');
            }
        }).catch(function (response) {
            // service failed
            console.log('service failure occured');
            console.log(response);
            // Analytics
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            // Modals
            activeModal.classList.remove('modal--closed');
            activeModal.classList.add('js-rich-text-modal-modal--opened');
            this.formLoader.classList.remove('active');
        });
    };
    WpbbsaManageAccessToReport.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    WpbbsaManageAccessToReport.prototype.closeModal = function () {
        var _this = this;
        if (this.activeModal) {
            this.activeModal.classList.add('modal--close');
        }
        else {
            this.activeModal = this.element.querySelector('.js-rich-text-modal-modal--opened');
            this.activeModal.classList.add('modal--close');
        }
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    WpbbsaManageAccessToReport.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-rich-text-modal-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    WpbbsaManageAccessToReport.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    WpbbsaManageAccessToReport.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    WpbbsaManageAccessToReport.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return '';
        }
    };
    return WpbbsaManageAccessToReport;
}(Base));
export { WpbbsaManageAccessToReport };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-manage-access-to-report/wpbbsa-manage-access-to-report.component.ts
// module id = 1078
// module chunks = 0